module.exports = __webpack_public_path__ + "img/no-search.e4c87904.png";